import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {AccountModel} from "../models/account.model";
import {AccountsQueryModel} from "../models/accounts-query.model";

@Injectable({providedIn: 'root'})
export class AccountsHttpService {

  private base_url = `/accounts`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAll(params?: any): Observable<{ cursor: string, list: AccountModel[] }> {
    return this.http
      .get<{ cursor: string, list: AccountModel[] }>(this.base_url, {params});
  }

  queryAccounts(body: AccountsQueryModel): Observable<{ cursor: string, list: AccountModel[] }> {
    const {branchIds, sort, ...bodyPayload} = body;
    const params: any = {};
    if (branchIds?.length) {
      params.branchIds = branchIds;
    }
    if (sort) {
      params.sort = sort;
    }
    return this.http
      .post<{ cursor: string, list: AccountModel[] }>(`${this.base_url}/query`, bodyPayload, {params});
  }

  getOne(accountId: string, params?: any): Observable<AccountModel> {
    return this.http
      .get<AccountModel>(`${this.base_url}/${accountId}`, {params})
  }

  createOne(account: AccountModel, params?: any): Observable<AccountModel> {
    return this.http
      .put<AccountModel>(this.base_url, account, {params})
  }

  updateOne(accountId: string, account: AccountModel, params?: any): Observable<AccountModel> {
    return this.http
      .post<AccountModel>(`${this.base_url}/${accountId}`, account, {params})
  }

  deleteOne(accountId: string, shouldMask: boolean, params?: any): Observable<AccountModel> {
    return this.http
      .delete<AccountModel>(`${this.base_url}/${accountId}`, {params: {mask: shouldMask, ...params}})
  }

  getPreferences(accountId: string, params?: any): Observable<any> {
    return this.http
      .get(`${this.base_url}/${accountId}/preferences`, {params});
  }

  updatePreferences(accountId: string, preferences: any, params?: any): Observable<any> {
    return this.http
      .post(`${this.base_url}/${accountId}/preferences`, preferences, {params});
  }

  getAccountPricePlanBundle(accountId: string, params?: any): Observable<any> {
    return this.http
      .get(`${this.base_url}/${accountId}/priceplan`, {params});
  }

  setAccountPricePlanBundle(accountId: string, bundleId: string, params?: any): Observable<any> {
    return this.http
      .post(`${this.base_url}/${accountId}/priceplan/${bundleId}`, {}, {params});
  }

  addUserToAccount(accountId: string, invitedUser: any, params?: any): Observable<any> {
    return this.http
      .post(`${this.base_url}/${accountId}/roles`, invitedUser, {params});
  }

  updateAccountsDepot(params?: any): Observable<AccountModel[]> {
    return this.http
      .post<AccountModel[]>(`${this.base_url}/depot`, {}, {params});
  }

  updateAccountConfigProfile(accountId: string, configProfile: any, params?: any): Observable<AccountModel> {
    const allParams = params || {};
    allParams.accountId = accountId;
    return this.http
      .post<AccountModel>(`${this.base_url}/configProfile`, configProfile, {params: allParams});
  }

  removeContract(accountId: string, params?: any): Observable<AccountModel> {
    return this.http
      .post<AccountModel>(`${this.base_url}/${accountId}/removeContract`, {}, {params});
  }

  unArchive(accountId: string, params?: any): Observable<AccountModel> {
    return this.http
      .post<AccountModel>(`${this.base_url}/unArchive`, {accountId}, {params});
  }

  addBranches(accountIds: string[], branchIds: string[], params?: any): Observable<AccountModel[]> {
    return this.http
      .post<AccountModel[]>(`${this.base_url}/addBranches`, {accountIds, branchIds}, {params});
  }

  removeBranches(accountIds: string[], branchIds: string[], params?: any): Observable<AccountModel[]> {
    return this.http
      .post<AccountModel[]>(`${this.base_url}/removeBranches`, {accountIds, branchIds}, {params});
  }

  updateBranches(accountIds: string[], branchIds: string[], params?: any): Observable<AccountModel[]> {
    return this.http
      .post<AccountModel[]>(`${this.base_url}/updateBranches`, {accountIds, branchIds}, {params});
  }


  getTotalStatuses(params?: any): Observable<any> {
    return this.http
      .get(`${this.base_url}/totals/statuses`, {params});
  }

  getCommissionsSummary(params?: any): Observable<any> {
    return this.http
      .get(`${this.base_url}/commissions/summary`, {params});
  }

  exportAccounts(payload: any, params?: any): Observable<any> {
    return this.http
      .post(`${this.base_url}/actions/export`, payload, {params});
  }
}
